import React from "react";
import stl from "./productImgSwiper.module.scss";
import { IStyleProps } from "@/src/app/interface";
import classnames from "classnames";

import CarouselSwiperClient from "./CarouselSwiperClient";
import ShowAIClient from "./ShowAIClient";
import ShowChangeVideoImgButton, {
    type Props as IShowChangeVideoImgButtonProps,
} from "./ShowChangeVideoImgButton";
import ProductImgSwiperClient from "./ProductImgSwiperClient";
import ShowSliderGuideClient from "./ShowSliderGuideClient";
import variable from "@/src/styles/variables.module.scss";
import FmImage from "@/ui-component/basic/FmImage";
import {
    ColorItem,
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import CarouselWrapper from "./CarouselWrapper";
import BannerShow, { getBannerShowData } from "./imgSwiperUtils";
import { useTranslation } from "@/src/i18n/client";

interface IProps extends IStyleProps, IShowChangeVideoImgButtonProps {
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
    activeObj: ColorItem;
}

const ProductImgSwiper: React.FC<IProps> =  (props) => {
    const { productDetail, activeObj } = props;
    const { t } = useTranslation('productDetail');
    const { list, productImgList } = getBannerShowData(
        productDetail,
        activeObj,
        t,
    );
    const imgList = list.map((item: string, index: number) => (
        <BannerShow
            key={`list-${index}`}
            image={item}
            index={index}
            productImgListLength={productImgList.length}
        />
    ));
 
    return (
        <ProductImgSwiperClient imgListNum={imgList.length}>
            <div
                className={classnames(
                    stl["product-slider-container"],
                    "product-slider-container",
                    props.className,
                )}
            >
                <div className={classnames(stl["carousel-container"])}>
                    <CarouselSwiperClient colorId={activeObj.id}>
                        {imgList.map((item: any, index: number) => (
                            <CarouselWrapper key={index} index={index}>
                                {item}
                            </CarouselWrapper>
                        ))}
                    </CarouselSwiperClient>
                    <ShowAIClient>
                        <svg
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            width="24"
                            height="24"
                        >
                            <path
                                d="M329.142857 347.428571a18.285714 18.285714 0 0 1 2.139429 36.443429L329.142857 384h-36.571428a91.428571 91.428571 0 0 0-91.337143 87.460571L201.142857 475.428571v182.857143a91.428571 91.428571 0 0 0 87.460572 91.337143L292.571429 749.714286h438.857142a91.428571 91.428571 0 0 0 91.337143-87.460572L822.857143 658.285714V475.428571a91.428571 91.428571 0 0 0-87.460572-91.337142L731.428571 384h-36.571428a18.285714 18.285714 0 0 1-2.139429-36.443429L694.857143 347.428571h36.571428a128 128 0 0 1 127.926858 123.611429L859.428571 475.428571v182.857143a128 128 0 0 1-123.611428 127.926857L731.428571 786.285714H292.571429a128 128 0 0 1-127.926858-123.611428L164.571429 658.285714V475.428571a128 128 0 0 1 123.611428-127.926857L292.571429 347.428571h36.571428z m54.857143 146.285715a36.571429 36.571429 0 1 1 0 73.142857 36.571429 36.571429 0 0 1 0-73.142857z m256 0a36.571429 36.571429 0 1 1 0 73.142857 36.571429 36.571429 0 0 1 0-73.142857z m44.745143-254.061715a18.285714 18.285714 0 0 1 8.173714 24.521143C664.941714 320.128 581.924571 384 512 384s-152.941714-63.853714-180.918857-119.826286a18.285714 18.285714 0 0 1 32.694857-16.347428C386.084571 292.443429 457.581714 347.428571 512 347.428571s125.915429-55.003429 148.224-99.602285a18.285714 18.285714 0 0 1 24.521143-8.173715z"
                                fill={variable.main}
                                p-id="5454"
                            ></path>
                        </svg>
                    </ShowAIClient>
                </div>
                <div
                    className={classnames(
                        "default_layout",
                        stl["video-container"],
                    )}
                >
                    <div style={{ width: "0.8rem" }}></div>
                    <ShowChangeVideoImgButton video={props.video} />
                </div>

                <ShowSliderGuideClient>
                    <span style={{ width: "1.2rem" }}>
                        <FmImage
                            image={
                                "https://df5apg8r0m634.cloudfront.net/images/afec8b8cb9ddd7f38e4e325ce143f7ef.png"
                            }
                        />
                    </span>
                </ShowSliderGuideClient>
            </div>
        </ProductImgSwiperClient>
    );
};

export default ProductImgSwiper;
